import PropTypes from 'prop-types';
import React from 'react';
import { map } from 'lodash';
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
} from 'react-bootstrap';
import accounting from 'accounting';
import { getCurrencySymbol } from 'components/modules/master/formatters';

const Units = [
  {
    name: 'Day',
    value: 'day',
  },
  {
    name: 'Hour',
    value: 'hour',
  },
  {
    name: 'Minute',
    value: 'minute',
  },
];

export default class AccessorialRatesTimeBaseEditor extends React.Component {
  constructor(props) {
    super(props);
    this.state = { accessorialRate: this.props.accessorialRate || {} };
  }

  onChange(property, e, isNumber) {
    const value = e.target.value;
    const accessorialRate = this.state.accessorialRate;
    accessorialRate[property] = value;
    this.setState({ accessorialRate: accessorialRate });
    this.props.onChange(property, isNumber ? Number(value) : value);
    const unit = accessorialRate.unit;
    let description = `${accounting.formatMoney(
      accessorialRate.rate,
      getCurrencySymbol(DEFAULT_CURRENCY),
    )} per ${unit}. `;
    description +=
      accessorialRate.free && accessorialRate.free > 0
        ? `First ${accessorialRate.free} ${unit}(s) for free. `
        : '';
    description +=
      accessorialRate.minimum_number && accessorialRate.minimum_number > 0
        ? `With ${accessorialRate.minimum_number} ${unit}(s) minimum. `
        : '';
    description +=
      accessorialRate.increment && accessorialRate.increment > 0
        ? `Increase by ${accessorialRate.increment} ${unit}(s). `
        : '';
    this.props.onChange('description', description);
  }
  handleRateChange() {
    return (e) => {
      this.onChange('rate', e, true);
    };
  }
  handleFreeChange() {
    return (e) => {
      this.onChange('free', e, true);
    };
  }
  handleMinNumberChange() {
    return (e) => {
      this.onChange('minimum_number', e, true);
    };
  }
  handleUnitChange() {
    return (e) => {
      this.onChange('unit', e, false);
    };
  }
  handleIncrementChange() {
    return (e) => {
      this.onChange('increment', e, true);
    };
  }
  validateRate(rate) {
    if (rate > 0) {
      return '';
    }
    return 'error';
  }
  validateValue(value) {
    if (value >= 0) {
      return '';
    }
    return 'error';
  }
  render() {
    const accessorialRate = this.state.accessorialRate;
    return (
      <Grid fluid>
        <Row className="show-grid">
          <Col xs={4}>
            <FormGroup>
              <ControlLabel>{accessorialRate.name}</ControlLabel>
              <FormControl
                type="number"
                defaultValue={accessorialRate.rate}
                onChange={this.handleRateChange()}
                bsStyle={this.validateValue(accessorialRate.rate)}
              />
            </FormGroup>
            <FormGroup>
              <ControlLabel>{`${accessorialRate.unit}s for free`}</ControlLabel>
              <FormControl
                type="number"
                defaultValue={accessorialRate.free}
                onChange={this.handleFreeChange()}
                bsStyle={this.validateValue(accessorialRate.free)}
              />
            </FormGroup>
            <FormGroup>
              <ControlLabel>{`Minimum ${accessorialRate.unit}s for charge`}</ControlLabel>
              <FormControl
                type="number"
                defaultValue={accessorialRate.minimum_number}
                onChange={this.handleMinNumberChange()}
                bsStyle={this.validateValue(accessorialRate.minimum_number)}
              />
            </FormGroup>
          </Col>
          <Col xs={1}>
            <div calssName="form-group" style={{ marginTop: 30 }}>
              <label>{`${getCurrencySymbol(DEFAULT_CURRENCY)} per`}</label>
            </div>
          </Col>
          <Col xs={4}>
            <FormGroup>
              &nbsp;
              <FormControl
                componentClass="select"
                defaultValue={accessorialRate.unit}
                onChange={this.handleUnitChange()}
              >
                {map(Units, (unit, index) => (
                  <option value={unit.value} key={`unit-${index}`}>
                    {unit.name}
                  </option>
                ))}
              </FormControl>
            </FormGroup>
            <FormGroup>
              <ControlLabel>{`${accessorialRate.unit}s for increment`}</ControlLabel>
              <FormControl
                type="number"
                defaultValue={accessorialRate.increment}
                onChange={this.handleIncrementChange()}
                bsStyle={this.validateValue(accessorialRate.increment)}
              />
            </FormGroup>
          </Col>
        </Row>
      </Grid>
    );
  }
}

AccessorialRatesTimeBaseEditor.propTypes = {
  accessorialRate: PropTypes.object,
  onChange: PropTypes.func,
};
